import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/reviews/help-center.svg")